import $ from 'jquery';

import {LOADING_CLASS_NAME, PRODUCT_IN_CART_CLASSNAME} from "./constants";

if(window.location.host.indexOf('localhost') == -1) {
    $.fn.cycle.log = function() {};
}


$(document).ready(function() {

    //select
    function select() {
        var el = $('.js-select');
        var el_title = el.find('span');
        var item = el.find('li');
        var list = el.find('ul');
        el_title.click(function() {
            el.removeClass('is-open');
            list.hide();
            $(this).parent().toggleClass('is-open');
            $(this).next().toggle();
        });
        item.click(function() {
            var val = $(this).text();
            $(this).parent().prev().addClass('is-selected');
            $(this).parent().prev().html(val + '<i></i>');
            $(this).parent().hide();
            el.removeClass('is-open');
        });
        el.click(function(event){
            event.stopPropagation();
        });

        $(document).on('click', function(e) {
            el.removeClass('is-open');
            el.find('ul').hide();
        });
    };

    //init
    select();

    // //number
    // function number() {
    //     $(document).on('click', '.number .number__plus', function(e){
    //         var $value = $(this).closest('.number').find('.number__val');
    //
    //         var val = $value.val();
    //         if (val >= 1) {
    //             $value.val(++val);
    //           $value.trigger('updated');
    //         };
    //     })
    //
    //
    //     $(document).on('click', '.number .number__minus', function(e){
    //         var $value = $(this).closest('.number').find('.number__val');
    //         var val = $value.val();
    //         if (val > 1) {
    //             $value.val(--val);
    //             $value.trigger('updated');
    //         };
    //     })
    //
    //     $(document).on('input keyup', '.number .number__val', function(e) {
    //         var value = parseInt($(this).val());
    //
    //         if(isNaN(value) || value == 0) {
    //             $(this).val(1);
    //         }
    //         $(this).trigger('updated');
    //     })
    // }
    // number();

    //tabs
    function tabs() {
        var el = $('.tabs');
        el.find('.tabs__item:not(:first)').hide();
        el.find('.tabs__nav > button').click(function() {
            if (!$(this).hasClass('is-active')) {
                $(this).parent().parent().find('.tabs__item').hide();
                $(this).parent().find('button').removeClass('is-active');
                $(this).addClass('is-active');
                var val = $(this).attr('data-item');
                $('#' + val).fadeIn();
            };
        });
    }
    tabs();


    $(document).on('click', '.cart__btn-order', function() {
        window.location.href = '/cart';
    });



    $('.sort__select ul li').not('.is-active').click(function() {
        var url = $(this).data('url');
        window.location.href = url;
    });

    //$("[data-role=phone]").mask("+38 (999) 999-99-99");
});

$(document).on('click', '.navmob-handle', function(e){
    $(this).closest('.navmob').toggleClass('js-opened');
});


/**
 * Update cart data after product added.
 */
function reloadSmallCart() {
    $("#cart").load('/cart/renderSmallCart');
}

/**
 * Add product to cart from list
 * @param data
 * @param textStatus
 * @param jqXHR
 * @param redirect
 */
function processCartResponseFromList(data, textStatus, jqXHR, redirect)
{
    var productErrors = $('#productErrors');

    if(data.errors) {
        window.location = redirect
    }else{
        reloadSmallCart();
        $("#cart").fadeOut().fadeIn().fadeOut().fadeIn();
    }
}


/**
 * Function executed after product added to cart
 */
function processCartResponse(data)
{
    var productErrors = $('#productErrors');
    if(data.errors) {
        // Display errors
        productErrors.html(data.errors.join('<br/>')).show();
    } else {
        // Display "Successful message"
        productErrors.hide();
        reloadSmallCart();
        //$.jGrowl("Товар успешно добавлен в корзину. <a href='/cart'>Перейти к оформлению</a>.", {position:"bottom-right"});
    }
}

/**
 * Rate product
 * @param id product id
 */
function rateProduct(id)
{
    var url = '/store/ajax/rateProduct/'+id;
    var rating = $('input[name=rating_'+id+']:checked').val();
    $('input[name=rating_'+id+']').rating('disable');
    $.ajax({
        url: url,
        data:{rating:rating}
    });

}

function applyCategorySorter(el) {
    window.location = $(el).val();
}

// function showCartPopup() {
//     var windowWidth = $(window).width();
//     if(windowWidth < 768) {
//         return false;
//     }
//
//     $.arcticmodal({
//         type: 'ajax',
//         url: '/ajaxCart'
//     });
// }

function number_format (number, decimals, dec_point, thousands_sep) {
    // http://kevin.vanzonneveld.net
    // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +     bugfix by: Michael White (http://getsprink.com)
    // +     bugfix by: Benjamin Lupton
    // +     bugfix by: Allan Jensen (http://www.winternet.no)
    // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +     bugfix by: Howard Yeend
    // +    revised by: Luke Smith (http://lucassmith.name)
    // +     bugfix by: Diogo Resende
    // +     bugfix by: Rival
    // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
    // +   improved by: davook
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Jay Klehr
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +      input by: Amir Habibi (http://www.residence-mixte.com/)
    // +     bugfix by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Theriault
    // +      input by: Amirouche
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: number_format(1234.56);
    // *     returns 1: '1,235'
    // *     example 2: number_format(1234.56, 2, ',', ' ');
    // *     returns 2: '1 234,56'
    // *     example 3: number_format(1234.5678, 2, '.', '');
    // *     returns 3: '1234.57'
    // *     example 4: number_format(67, 2, ',', '.');
    // *     returns 4: '67,00'
    // *     example 5: number_format(1000);
    // *     returns 5: '1,000'
    // *     example 6: number_format(67.311, 2);
    // *     returns 6: '67.31'
    // *     example 7: number_format(1000.55, 1);
    // *     returns 7: '1,000.6'
    // *     example 8: number_format(67000, 5, ',', '.');
    // *     returns 8: '67.000,00000'
    // *     example 9: number_format(0.9, 0);
    // *     returns 9: '1'
    // *    example 10: number_format('1.20', 2);
    // *    returns 10: '1.20'
    // *    example 11: number_format('1.20', 4);
    // *    returns 11: '1.2000'
    // *    example 12: number_format('1.2000', 3);
    // *    returns 12: '1.200'
    // *    example 13: number_format('1 000,50', 2, '.', ' ');
    // *    returns 13: '100 050.00'
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

var addProductToCartHandler = function($form, action, data) {

  const CLASSNAME_LOADING = 'loading';
  const CLASSNAME_PRODUCT_IN_CART = 'product-added';

  return $.ajax({
    url: action,
    data: data,
    type: "POST",
    dataType: "json",
    beforeSend: () => {
      $form.addClass(CLASSNAME_LOADING);
    },
    success: () => {
      $form.removeClass(CLASSNAME_LOADING);
      $form.addClass(CLASSNAME_PRODUCT_IN_CART);
    },
    error: () => {
      $form.removeClass(CLASSNAME_LOADING);
    }
  })
};

var addProductToCartHandler = function($form, action, data) {

  return $.ajax({
    url: action,
    data: data,
    type: "POST",
    dataType: "json",
    beforeSend: () => {
      $form.addClass(LOADING_CLASS_NAME);
    },
    success: () => {
      $form.addClass(PRODUCT_IN_CART_CLASSNAME);
    },
    complete: () => {
       $form.removeClass(LOADING_CLASS_NAME);
    }
  })
};

$(document).on('submit', 'form[data-role=add-list-product]', function(e) {
    e.preventDefault();

    var $form = $(this);
    var action = $form.attr('action');
    var data = $form.serialize();
    var variantSku = $form.data('sku') || 0;

    addProductToCartHandler($form, action, data).then(() => {
      reloadSmallCart();
    });
});

$(document).on('submit', 'form[data-role=add-product]', function(e) {
    e.preventDefault();
    var $form = $(this);
    var action = $form.attr('action');
    var data = $form.serialize();

    addProductToCartHandler($form, action, data).then(() => {
      reloadSmallCart();
    });

});

$(document).on('click', '[data-url]', function(e){
    e.preventDefault();
    var url = $(this).data('url');
    window.location.href = url;
});

function TopAlertData(cookieKey) {
    this.set = function(value) {
        $.cookie(cookieKey, value, { expires: 1 });
    };

    this.get = function() {
        return $.cookie(cookieKey);
    }

}

function TopAlertManager(topAlertView, topAlertData) {
    this.init = function() {
        if(topAlertData.get()) {
            topAlertView.hide();
        } else {
            topAlertView.handleClickClose(this.handle);
        }
    };

    this.handle = function() {
        topAlertView.hide();
        topAlertData.set(true);
    };
}

function TopAlertView($container) {
    this.handleClickClose = function(callback) {
        $container.find('.flash__message-close').click(function(e) {
            e.preventDefault();
            callback($container);
        });
    };

    this.hide = function() {
        $container.slideUp();
    }
}

$(document).ready(function(){
    var $container = $('.flash__message');

    if($container.length) {
        var topAlertData = new TopAlertData($container.data('cookie-key'));

        var topAlertView = new TopAlertView($container);
        var topAlertManager = new TopAlertManager(topAlertView, topAlertData);

        topAlertManager.init();
    }
});

window.addEventListener('load', function() {

    var map = document.getElementById('map');

    if(!document.body.contains(map)) {
        return;
    }

    var coordinates = [50.400186, 30.628688];
    var content = '<h2>Obagimed.com.ua</h2> <p><ins>Пункт самовывоза находиться по адресу:</ins></p> <p>Украина, Киев,<br>ул. Срибнокильска 2-A</p>';

    var map = L.map('map').setView(coordinates, 17);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    L.marker(coordinates).addTo(map)
        .bindPopup(content)
        .openPopup();

});




// WEBPACK FOOTER //
// ./frontend/src/common.js